module.exports = __webpack_public_path__ + "assets/d74db00e66197cb607a96538cfea0e9b.png";